import React, { useState } from "react";
import "../DualAgency/index.css";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
} from "antd";
import TextArea from "antd/es/input/TextArea";

const Index = ({ setActive }) => {
  const [form] = Form.useForm();
  const [showInput, setShowInput] = useState({
    seller1: false,
    seller2: false,
  });
  const [showBuyer, setShowBuyer] = useState({
    buyer1: false,
    buyer2: false,
  });

  const submit = async (value) => {
    setActive(true);
    // alert(JSON.stringify(value));
    let res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/dual-agency`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(value),
    });
    console.log(res);
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Dual Agency"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
    setActive(false);
  };

  const check = (value) => {
    const newState = {
      seller1: value.includes("seller1"),
      seller2: value.includes("seller2"),
    };
    setShowInput(newState);
  };

  const seller = (value) => {
    const newState = {
      buyer1: value.includes("buyer1"),
      buyer2: value.includes("buyer2"),
    };
    setShowBuyer(newState);
  };

  return (
    <div className="main">
      <Form form={form} onFinish={submit} autoComplete="off">
        <label>Notice Of Dual Agency</label>
        <Row gutter={16} justify={"space-between"}>
          <Col md={10}>
            <label>Property Address</label>
            <Form.Item
              name={"property_address"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={5}>
            {" "}
            <label>Date:</label>
            <Form.Item
              name={"date"}
              rules={[{ required: true, message: "required" }]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col md={9}>
            {" "}
            <label>Name of Agent & License</label>
            <Form.Item
              name={"name_of_agent"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name={"seller_check"}>
          <Checkbox.Group onChange={check}>
            <Row>
              <Col>
                <Checkbox value={"seller1"}>Seller 1</Checkbox>
                {showInput.seller1 && (
                  <Form.Item
                    name={"seller_1_input"}
                    rules={[{ required: true, message: "required" }]}
                  >
                    <Input placeholder="Seller Name" />
                  </Form.Item>
                )}
              </Col>
              <Col>
                <Checkbox value={"seller2"}>Seller 2</Checkbox>
                {showInput.seller2 && (
                  <Form.Item
                    name={"seller_2_input"}
                    rules={[{ required: true, message: "required" }]}
                  >
                    <Input placeholder="Seller Name" />
                  </Form.Item>
                )}
              </Col>
            </Row>
          </Checkbox.Group>
        </Form.Item>

        <Form.Item
          name={"buyer_check"}
          rules={[{ required: true, message: "required" }]}
        >
          <Checkbox.Group onChange={seller}>
            <Row style={{ marginTop: "2rem" }}>
              <Col>
                <Checkbox value={"buyer1"}>Buyer 1</Checkbox>
                {showBuyer.buyer1 && (
                  <Form.Item
                    name={"buyer_1_input"}
                    rules={[{ required: true, message: "required" }]}
                  >
                    <Input placeholder="Buyer Name" />
                  </Form.Item>
                )}
              </Col>
              <Col>
                <Checkbox value={"buyer2"}>Buyer 2</Checkbox>
                {showBuyer.buyer2 && (
                  <Form.Item
                    name={"buyer_2_input"}
                    rules={[{ required: true, message: "required" }]}
                  >
                    <Input placeholder="Buyer Name" />
                  </Form.Item>
                )}
              </Col>
            </Row>
          </Checkbox.Group>
        </Form.Item>
        <hr />
        <label>Consent To Dual Agency</label>

        <Row gutter={16} justify={"space-between"}>
          <Col md={8}>
            <label>Agent Name & License #</label>
            <Form.Item
              name={"licence"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="licence" />
            </Form.Item>
          </Col>
          <Col md={8}>
            <label>Seller's Name</label>
            <Form.Item
              name={"name_seller"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="seller" />
            </Form.Item>
          </Col>
          <Col md={8}>
            <label>Buyer's Name</label>
            <Form.Item
              name={"name_buyer"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="buyer" />
            </Form.Item>
          </Col>
        </Row>
        <label>Ageny License #</label>
        <Form.Item
          name={"form_licence"}
          rules={[{ required: true, message: "required" }]}
        >
          <Input placeholder="Licence Number" />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" type="primary">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Index;
